import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // We cannot use hooks in class components; use a lightweight fetch here
    // Import API_URL at runtime to avoid module scope issues
    import('../config').then(({ API_URL }) => {
      try {
        // Notify + post using the same backend endpoint
        fetch(`${API_URL}/logs/error`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            level: 'error',
            message: 'React error',
            stack: error?.stack,
            componentStack: info?.componentStack,
            route: typeof window !== 'undefined' ? window.location.pathname : undefined,
          }),
        }).catch(() => {});
      } catch {}
    }).catch(() => {});
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      // Swallow the error and render nothing; Notification UI handles user message
      return <></>;
    }
    return this.props.children as React.ReactElement;
  }
}


